/**
 * Textos de Compres (`es`): tall «filtres» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `es.ts`.
 * Filtres de les llistes d'Albarans, Excepcions i Devolucions (OBR-181). Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 * El proveïdor i «Treu els filtres» reutilitzen les claus de Comandes (`backoffice.purchaseOrders`).
 */

export const filtresEs = {
  'backoffice.purchaseFilters': {
    receptionsSearch: 'Buscar por albarán, pedido, proveedor o factura',
    receptionsStatusConfirmed: 'Confirmado',
    receptionsStatusDraft: 'Borrador',
    receptionDateFrom: 'Recepción desde',
    receptionDateTo: 'Recepción hasta',
    receptionsEmptyFiltered: 'Ningún albarán encaja con estos filtros. Prueba a ampliarlos o quítalos.',
    exceptionsSearch: 'Buscar por albarán, pedido, proveedor o artículo',
    exceptionsEmptyFiltered: 'Ninguna excepción encaja con estos filtros. Prueba a ampliarlos o quítalos.',
    returnsSearch: 'Buscar por devolución, albarán, pedido, proveedor, artículo o lote',
    returnsDateFrom: 'Creada desde',
    returnsDateTo: 'Creada hasta',
    returnsEmptyFiltered: 'Ninguna devolución encaja con estos filtros. Prueba a ampliarlos o quítalos.',
  },
} as const;
